import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Text } from '@backstage/ui';

import { DateUtils } from '@spotify/confidence-core-react';

const styles = createStyles({
  root: {},
});

export interface TimestampProps extends WithStyles<typeof styles> {
  className?: string;
  timestamp: string;
}

const Timestamp = forwardRef<HTMLParagraphElement, TimestampProps>(
  (props, ref) => {
    const { className, classes, timestamp, ...rest } = props;

    return (
      <Text
        ref={ref}
        as="span"
        variant="body-small"
        color="secondary"
        className={classNames(classes.root, className)}
        {...rest}
      >
        {DateUtils.xAgo(new Date(timestamp))}
      </Text>
    );
  },
);

Timestamp.displayName = 'ActivityFeedItem.Timestamp';

export default withStyles(styles)(Timestamp);
